import { connect } from 'react-redux'
import flowRight from 'lodash/flowRight'

import withFormMeta from '../withFormMeta'
import { makeGetCheckboxDisabled } from './selectors'

const makeMapStateToProps = () => {
  const getCheckboxDisabled = makeGetCheckboxDisabled()
  return (state, props) => ({
    // @ts-ignore
    checkboxDisabled: getCheckboxDisabled(state, props),
  })
}

export default flowRight(withFormMeta, connect(makeMapStateToProps))
